import type { NavigationData, Position, Verb } from "../../../config/interactive/types";
import useVerbHandlers from "../../hooks/useVerbHandlers";
import { eventInteractiveClick } from "../../utils/gtag";
import Focusable from "./Focusable";
import IconOnFocus from "./IconOnFocus";
import IconToggleOnFocus from "./IconToggleOnFocus";

type props = {
	position: {
		hitbox: Position;
		icon: Position;
	};
	src: string;
	navigation: NavigationData;
	hoveredSrc?: string;
	verbs: Verb[];
	isProtected: boolean;
	isFocused: boolean;
	isFaded: boolean;
};

export default function InteractiveComponent({
	verbs,
	position,
	src,
	hoveredSrc,
	navigation,
	isProtected,
	isFocused,
	isFaded,
}: props) {
	const verbHandlers = useVerbHandlers();

	const onClick = () => {
		if (isFaded) {
			return;
		}
		const verbNames = verbs.map((verb) => verb.name).join(", ");
		eventInteractiveClick(navigation.id, verbNames, isProtected);
		verbs.forEach((verb) => {
			const handler = verbHandlers[verb.name];
			if (handler) {
				handler(verb.data as any);
			} else {
				console.error("Unknown verb:", verb);
			}
		});
	};

	const navigateTo = verbs.filter((verb) => verb.name === "NAVIGATE");

	// Undefined behavior
	if (navigateTo.length > 1) {
		console.error("There was an issue with navigate action", navigation.id, navigateTo, verbs);
	}

	const { hitbox, icon } = position;

	return (
		<>
			<Focusable
				position={hitbox}
				onClick={onClick}
				navigation={navigation}
				linkTo={navigateTo[0]?.data.url}
				isProtected={isProtected}
			/>
			{src &&
				(hoveredSrc ? (
					<IconToggleOnFocus
						position={hitbox}
						src={src}
						hoveredSrc={hoveredSrc}
						isFocused={isFocused}
					/>
				) : (
					<IconOnFocus position={icon} src={src} isFocused={isFocused} />
				))}
		</>
	);
}
